import * as actionTypes from './subActionMenuActionTypes';

export const setSubActionMenuAnchorEl = (subAnchorEl) => ({type: actionTypes.SET_SUB_ACTION_MENU_ANCHOR_EL, subAnchorEl: subAnchorEl});
export const setSubActionMenuPlacement = (subPlacement) => ({type: actionTypes.SET_SUB_ACTION_MENU_PLACEMENT, subPlacement: subPlacement});
export const setSubActionMenuOpen = (open) => ({type: actionTypes.SET_SUB_ACTION_MENU_OPEN, open: open});
export const setSubActionMenuId = (id) => ({type: actionTypes.SET_SUB_ACTION_MENU_ID, id: id});


